import React, { Component } from "react";
import RankingDialog from "../../components/results/RankingDialog";
import Button from "@material-ui/core/Button";
import ChartIcon from "@material-ui/icons/ShowChart";
import { languages } from "../../constants/languages";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { getRankingPerDivision } from "../../util/GetRankingPerDivision";

const styles = (theme) => ({
  button: {
    position: "absolute",
    right: 130,
    top: 65,
    [theme.breakpoints.down("xs")]: {
      top: 55,
    },
  },
  buttonOnline: {
    position: "absolute",
    right: 0,
    top: 65,
    [theme.breakpoints.down("xs")]: {
      top: 55,
    },
  },
});

class RankingContainer extends Component {
  state = {
    open: false,
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    let showPlayerStats = false;
    if (Object.keys(this.props.tournament.playerPoints || {}).length > 0) {
      showPlayerStats = true;
    }
    let toRender = null;
    if (this.state.open) {
      let ranking = getRankingPerDivision(
        this.props.divisions,
        this.props.poules,
        this.props.brackets,
        this.props.resultSpotsAll,
        this.props.tournament,
        this.props.matches,
        this.props.teams
      );
      toRender = (
        <RankingDialog
          open={this.state.open}
          handleClose={this.toggleDialog}
          {...this.props}
          // rankingPerDivision={rankingPerDivision}
          ranking={ranking.ranking}
          showPlayerStats={showPlayerStats}
          customPoints={ranking.customPoints}
        />
      );
    }
    return (
      <div>
        {toRender}
        <Button
          size="small"
          variant="outlined"
          color="default"
          onClick={this.toggleDialog}
          className={
            false // this.props.tournament.online
              ? this.props.classes.buttonOnline
              : this.props.classes.button
          }
          style={{ marginRight: 10 }}
        >
          {languages.results.ranking}
          <ChartIcon style={{ height: 16, width: 16 }} />
        </Button>
      </div>
    );
  }
}

RankingContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RankingContainer);
